import React from "react";
import { Grid, styled } from "@mui/material";
import FormInfo from "components/haven-design/form/info";
import Header from "components/header";
import { Footer } from "../layout";

const CenteredSpan = styled("span")({
  textAlign: "center",
  display: "block",
});

const FormCompleted: React.FC = () => (
  <>
    <Header />
    <div className="container">
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <FormInfo title="Form completed" type="Success">
            <CenteredSpan>
              <br />
              <span style={{ fontSize: 32 }} className="fa fa-thumbs-up" />
              <br />
              <br />
              You&apos;ve already completed the form!
            </CenteredSpan>
          </FormInfo>
        </Grid>
      </Grid>
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
        <Footer />
      </div>
    </div>
  </>
);

export default FormCompleted;
